import { createSlice } from '@reduxjs/toolkit';

export type FormState = {
  isReset: boolean;
}

export const initialState: FormState = {
  isReset: false
};

const form = createSlice({
  name: 'form',
  initialState,
  reducers: {
    resetForm: (state) => {
      state.isReset = true;
    },

    clearResetForm: (state) => {
      state.isReset = false;
    }
  }
});

export const {
  resetForm, clearResetForm
} = form.actions;

export default form.reducer;
